import styled from "styled-components";

export const Container = styled.div`
  padding: 0 16px;
`;

export const Title = styled.h3`
  color: ${({ tema }) => tema.primaryColor};
  font-size: 20px;
`;

export const List = styled.ol`
  counter-reset: item;
  list-style-type: none;
  padding: 0;
  padding-left: 10px;
`;

export const ListItem = styled.li`
  font-size: 18px;
  position: relative;
  margin: 16px 0;
  p {
    display: inline;
    margin-left: 24px;
    color: #4d4d4d;
  }

  &:before {
    content: counter(item) "";
    counter-increment: item;
    color: ${({ tema }) => tema.primaryColor};
  }
  &:after {
    content: "";
    padding: 5px;
    width: 16px;
    height: 16px;
    position: absolute;
    border: 2px solid ${({ tema }) => tema.primaryColor};
    left: -10px;
    top: -5px;
    border-radius: 50%;
  }
`;
